// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import venueApi from '~/apis/venue';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  CREATE_VENUE,
  DELETE_VENUE,
  GET_DETAIL_VENUE,
  GET_LIST_VENUE,
  UPDATE_VENUE,
} from '~/utils/constants/actionType';
import { IQueryParamVenue } from '~/utils/interface/venue';

export const getListVenue = createAsyncThunk(GET_LIST_VENUE, async (params: IQueryParamVenue, { rejectWithValue }) => {
  try {
    const resp = await venueApi.getListVenue(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createVenue = createAsyncThunk(CREATE_VENUE, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await venueApi.createVenue(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteVenue = createAsyncThunk(DELETE_VENUE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await venueApi.deleteVenue(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const editVenue = createAsyncThunk(UPDATE_VENUE, async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
  try {
    const resp = await venueApi.editVenue(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailVenue = createAsyncThunk(GET_DETAIL_VENUE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await venueApi.getDetailVenue(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
